module.exports = __webpack_public_path__ + "img/kanahei.8d1d2045.gif";